import { useState, useEffect, useCallback } from "react";
import styles from "./main-history.module.scss";
import { HistoryContent } from "../../../types/types";

interface MainHistoryProps {
  duration?: number;
  onClose?: () => void;
  autoClose?: boolean;
}

const MainHistory = ({
  duration = 7000,
  onClose,
  autoClose = true,
}: MainHistoryProps) => {
  const [progress, setProgress] = useState(0);
  const [isVisible, setIsVisible] = useState(true);
  const [historyData, setHistoryData] = useState<HistoryContent | null>({
    from: "fcore",
    content: "./history_one.png",
    text: "Выпустили Telegram Mini App специально для вас!",
    date: new Date(2026, 0, 7, 17, 22),
    type: "photo",
  });

  // Функция для закрытия истории
  const handleClose = useCallback(() => {
    setIsVisible(false);
    setTimeout(() => {
      onClose?.();
    }, 300);
  }, [onClose]);

  useEffect(() => {
    if (!autoClose) return;

    const totalTime = duration;
    const intervalTime = 50;
    const increment = (intervalTime / totalTime) * 100;

    let progressTimer: NodeJS.Timeout;
    let closeTimer: NodeJS.Timeout;

    progressTimer = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 100) {
          clearInterval(progressTimer);
          return 100;
        }
        return Math.min(prev + increment, 100);
      });
    }, intervalTime);

    closeTimer = setTimeout(() => {
      handleClose();
    }, totalTime);

    return () => {
      clearInterval(progressTimer);
      clearTimeout(closeTimer);
    };
  }, [duration, autoClose, handleClose]);

  // Обработчик клика по истории
  const handleHistoryClick = () => {
    handleClose();
  };

  // Обработчик клика по области прогресса (чтобы не закрывалось при клике на хедер)
  const handleHeaderClick = (e: React.MouseEvent) => {
    e.stopPropagation(); // Останавливаем всплытие, чтобы не закрывалось при клике на хедер
  };

  const formatDate = (date: Date): string => {
    return date.toLocaleDateString("ru-RU").replace(/\//g, ".");
  };

  return (
    <div
      className={`${styles.main__history} ${!isVisible ? styles.close : ""}`}
      onClick={handleHistoryClick}
    >
      <div className={styles.history__header} onClick={handleHeaderClick}>
        <div className={styles.progress}>
          <div
            className={styles.progress__fill}
            style={{ width: `${progress}%` }}
          />
        </div>
        <div className={styles.history__info}>
          <img
            src={historyData?.from === "fcore" ? "./fcore_logo.png" : ""}
            alt=""
            className={styles.history__avatar}
          />
          <div className={styles.info__text}>
            <p className={styles.info__name}>
              {historyData?.from === "fcore" ? "Fcore — Digital агентство" : ""}
            </p>
            <p className={styles.info__date}>
              {historyData?.date ? formatDate(historyData.date) : ""}
            </p>
          </div>
        </div>
      </div>
      <section className={styles.history__content}>
        {historyData?.type === "photo" ? (
          <img src={historyData.content} alt="story" />
        ) : (
          <video src={historyData?.content} autoPlay muted loop />
        )}
      </section>
      <div className={styles.history__bottom}>
        <p>{historyData?.text}</p>
      </div>
    </div>
  );
};

export default MainHistory;
